import { RequestConfig, RequestPerformer } from '../../types';
import { RegisterCancelFn } from '../../types/RegisterCancelFn';

export const createRequestInstance =
  (performRequest: RequestPerformer) =>
  async <ResponseType>(
    requestConfig: RequestConfig,
    registerCancel: RegisterCancelFn = () => {},
  ) => {
    const controller = new AbortController();
    registerCancel((reason?: unknown) => controller.abort(reason));

    return performRequest<ResponseType>({
      ...requestConfig,
      signal: controller.signal,
    });
  };
